import { useMemo } from "react";
import { FinancialAccountType } from "@common/types/financialAccount";
import { FINANCIAL_ACCOUNT_TYPE_LABEL } from "@common/constants";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { DisabledWithTooltip } from "@design-system/DisabledWithTooltip/DisabledWithTooltip";

interface Props {
    value?: FinancialAccountType;
    onChange: (value: FinancialAccountType) => void;
    allowedTypes?: FinancialAccountType[];
    disabledReason?: string;
}

export const FinancialAccountFinancialTypeSelect: React.FC<Props> = ({
    value,
    onChange,
    allowedTypes,
    disabledReason,
}) => {
    const items = useMemo<Array<PickerItemData<FinancialAccountType>>>(
        () =>
            (allowedTypes ?? Object.values(FinancialAccountType)).map(
                (type) => ({
                    value: type,
                    label: FINANCIAL_ACCOUNT_TYPE_LABEL[type],
                }),
            ),
        [allowedTypes],
    );

    return (
        <DisabledWithTooltip reason={disabledReason}>
            <Picker.Select
                items={items}
                value={value ?? null}
                onValueChange={(newValue) => {
                    if (newValue) {
                        onChange(newValue);
                    }
                }}
                disabled={!!disabledReason}
                placeholder="Select type"
                renderValue={() =>
                    value ? FINANCIAL_ACCOUNT_TYPE_LABEL[value] : undefined
                }
                trigger={<Picker.Button variant="primary" size="md" block />}
            />
        </DisabledWithTooltip>
    );
};
